import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';

export const authConfig = {
  Cognito: {
    userPoolId: String(process.env.REACT_APP_AWS_USER_POOL_ID),
    userPoolClientId: String(process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID),
    loginWith: {
      oauth: {
        domain: String(process.env.REACT_APP_AWS_COGNITO_DOMAIN),
        scopes: ["aws.cognito.signin.user.admin", 'email', 'openid', 'phone', 'profile'],
        redirectSignIn: process.env.REACT_APP_POST_LOGIN_PATH ? process.env.REACT_APP_POST_LOGIN_PATH.split(',') : [],
        redirectSignOut: process.env.REACT_APP_POST_LOGOUT_PATH ? process.env.REACT_APP_POST_LOGOUT_PATH.split(',') : [],
        responseType: 'code',
      }
    }
  }
};

Amplify.configure(
  {
    Auth: authConfig,
  },
  { ssr: true }
);

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({ domain: `${process.env.REACT_APP_DOMAIN}` }));

export default function ConfigureAmplifyClientSide() {
  return null;
}